module.exports = "images/categories.8ca43294.png";